import styled from "styled-components";

export const OpacityContainer = styled.div<WithOpacityProps>`
  ${({ animated = true }) => animated && `transition: opacity 0.5s;`}
  ${({ show, opacity }) => `opacity: ${show ? "1" : opacity ? opacity : "0"};`}
`;

interface WithOpacityProps {
  show: boolean;
  animated?: boolean;
  opacity?: string;
}

export const withOpacity = <T extends object>(
  WrappedComponent: React.FunctionComponent<T>
) => ({ show, animated, opacity, ...props }: T & WithOpacityProps) => (
  <OpacityContainer show={show} animated={animated} opacity={opacity}>
    <WrappedComponent {...(props as T)} />
  </OpacityContainer>
);
